<script>
  import { _ } from 'svelte-i18n'
  import { modals, flash_content, user_saved_selections, detected_fonts } from '../../stores'
  import { saveSelection } from '../../modules/saveSelection'
  import { filter } from 'lodash'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'
  import ButtonGroup from '../../elements/ButtonGroup.svelte'
  import Tabs from '../../elements/Tabs.svelte'
  import SavedSelectionList from '../SavedSelectionList.svelte';

  let modal_id = 'saveSelection'
  let button_busy = false
  let form_element
  let show_save_error = false
  let selected_tab = "new"
  let selected_selection
  let fonts_to_save_length

  const tab_options = [
    {value:'new', display:'Save new'}, 
    {value:'update', display:'Update previously saved'}
  ]

  async function handleSubmit(event) {

    fonts_to_save_length = filter($detected_fonts, 'selected').length
    button_busy = true
    show_save_error = false

    let response = await saveSelection(selected_selection)
    console.log(response)
    if (response === false) {
      show_save_error = true
    } else {
      modals.close()
      console.log('User - saved selection')
      $flash_content = {
        message: $_('flashes.userSavedSelection', { values: { selection_count: fonts_to_save_length } }),
        bright: true
      }
      resetModalVars()
    }
  }

  const handleSelect = (event) => {
    if (selected_selection === event.detail) {
      selected_selection = undefined
    } else {
      selected_selection = event.detail
    }
  }

  function resetModalVars() {
    selected_selection = undefined
    selected_tab = 'new'
  }

</script>

<Modal id={modal_id} large={selected_tab==="update"} on:modalClosed={resetModalVars} flush_header>
  <span slot="header">
    {#if selected_tab === "new"}
      {$_('modals.saveSelection.titleNew')}
    {:else}
      {$_('modals.saveSelection.titleUpdate')}
    {/if}
  </span>
  <span slot="content">
    <Tabs tab_options={tab_options} flush={true} bind:selected_tab={selected_tab} />
    <FormError bind:visible={show_save_error}>{@html $_('modals.saveSelection.saveError')}</FormError>
    <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
      {#if selected_tab==="new"}
        <p class="info">
          {$_('modals.saveSelection.saveNew')}
        </p>
      {/if}
      {#if selected_tab==="update"}
        {#if !!$user_saved_selections}
          <p class="info">
            {$_('modals.saveSelection.chooseToUpdate')}
          </p>
          <SavedSelectionList {selected_selection} on:selectionSelect={handleSelect}/>
        {:else}
          <div class="empty_state">
            <h3>{$_('modals.loadSelection.emptyTitle')}</h3>
            {@html $_('modals.saveSelection.emptyState')}
          </div>
        {/if}
      {/if}
      <ButtonGroup mt={3}>
        <Button 
          kind="accent" 
          type="submit" 
          disabled={selected_tab === "update" && !selected_selection}
          busy={button_busy}>
            {selected_tab === "new" ? $_('buttons.save') : $_('buttons.update')}
        </Button>
        <Button kind="outline" on:click={() => {modals.close(); resetModalVars()}}>{$_('buttons.cancel')}</Button>
      </ButtonGroup>
    </form>
  </span>
</Modal>

<style>
  .info {
    margin-bottom: 2rem;
  }
  .empty_state {
    padding: 2rem 1.5rem;
    background-color: var(--c-bg);
    border-radius: 1rem;
    color: var(--c-text-faded);
  }

  .empty_state h3 {
    margin-bottom: 1rem;
    color: var(--c-text);
  }
</style>